import { makeRequest } from "@/lib/xhr";

const ls = {
  get: () => JSON.parse(localStorage.getItem("recentlyViewed")),
  set: val => localStorage.setItem("recentlyViewed", val),
};

export const updateRecentProducts = product => {
  let recentlyViewed = [];
  const requestUrl = `${theme.routes.products}/${encodeURIComponent(
    product.handle
  )}?section_id=quick-cart-recently-viewed-item`;

  // Create markup for quickCart through liquid template
  // We are not storing markup for the recently-viewed Section
  // because it can become stale depending on option changes
  makeRequest("GET", requestUrl).then(response => {
    let container = document.createElement("div");
    container.innerHTML = response;

    const quickCartItem = container.querySelector(
      "[data-recently-viewed-item]"
    ).innerHTML;

    product.quickCartMarkup = quickCartItem;
    if (ls.get() !== null) {
      recentlyViewed = ls.get().filter(item => item.id !== product.id);

      recentlyViewed.unshift(product);
      ls.set(JSON.stringify(recentlyViewed.slice(0, 20)));
    } else if (ls.get() === null) {
      recentlyViewed.push(product);
      ls.set(JSON.stringify(recentlyViewed));
    }
  });
};

export const resetRecentProducts = () =>
  localStorage.removeItem("recentlyViewed");

export const getRecentProducts = () => ls.get();
